<style lang="scss" scoped>
    .echarts-title{
        height: 24px;
        line-height: 24px;
        text-align: center;
        font-size: 14px;
        color: #0ff;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .echarts-wrap{
        .echarts-type{
            padding-top: 5px;
            text-align: right;
        }
        .echarts-mian{
            display: flex;
            .echarts-cate{
                padding-top: 50px;
                margin-right: 10px;
                p {
                    margin: 10px 0;
                    text-align: right;
                }
            }
            .echarts-box{
                flex: 1;
                position: relative;
                .echarts{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #0ff;
                    font-size: 12px;
                }
                .select-time{
                    position: absolute;
                    top: 10px;
                    right: 0;
                    z-index: 10;
                }
                .echarts-state{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .state-item{
                        display: flex;
                        align-items: center;
                        height: 24px;
                        line-height: 24px;
                        font-size: 14px;
                        .state-icon{
                            width: 20px;
                            height: 20px;
                            margin-right: 5px;
                        }
                    }
                }
            }
        }
        .ivu-switch-disabled{
            cursor: pointer;
            &:after{
                cursor: pointer;
            }
            &.ivu-switch-checked{
                opacity: 1;
            }
        }
    }
    .modal-content{
        display: flex;
        padding: 30px 0;
        span{
            font-size: 14px;
            margin-right: 10px;
            em{
                color: red;
                font-size: 18px;
                margin-right: 5px;
            }
        }
        .ivu-input-wrapper{
            flex: 1;
        }
    }
</style>
<template>
    <div>
        <Row :gutter="10">
            <Col span="8" v-for="(item,index) in title" :key="index">
                <div class="echarts-title" :title="`${item.title}：${item.name}`">{{item.title}}：{{item.name}}</div>
            </Col>
        </Row>
        <div class="echarts-wrap">
            <!-- <div class="echarts-type">
                <ButtonGroup v-if="dataType.length">
                    <Button v-for="(item,index) in dataType" size="small" 
                        :type="index == activeType ? 'primary' : 'default'" 
                        :key="index"
                        @click="selectType(index)"
                        >
                        {{item}}
                    </Button>
                </ButtonGroup>
            </div> -->
            <div class="echarts-mian">
                <div class="echarts-cate" v-if="cateList[activeType].length">
                    <p v-for="(item,index) in cateList[activeType]" :key="index">
                        <Button size="small" 
                            :type="index == activeCate ? 'primary' : 'default'" 
                            @click="selectCate(index)"
                        >
                            {{item.title}}
                        </Button>
                    </p>
                </div>
                <div class="echarts-box">
                    <div class="select-time" v-if="dataTime.length">
                        <ButtonGroup>
                            <Button v-for="(item,index) in dataTime" size="small" 
                                :type="index == activeTime ? 'primary' : 'default'" 
                                :key="index"
                                @click="selectTtme(index)"
                                >
                                {{item.title}}
                            </Button>
                        </ButtonGroup>
                    </div>
                    <div class="echarts" :id="id" :style="{width: width, height:height}">暂无数据</div>
                    <div class="echarts-state">
                        <div class="state-item">
                            <span>在线状态：</span>
                            <img v-if="stateActive" class="state-icon" src="../../assets/img/network-monitor/icon-zx.png">
                            <img v-else class="state-icon" src="../../assets/img/network-monitor/icon-lx.png">
                        </div>
                        <div class="state-item">
                            <span>报警状态：</span>
                            <img class="state-icon" style="width:14px;height:14px;" src="../../assets/img/network-monitor/icon-bj.png">
                            <span style="color:#ed4014;">{{alarmCount}}</span>
                        </div>
                        <div class="state-item">
                            <span>预警状态：</span>
                            <img class="state-icon" style="width:14px;height:14px;" src="../../assets/img/network-monitor/icon-yj.png">
                            <span style="color:#ed4014;">{{warnCount}}</span>
                        </div>
                        <div class="state-item" v-if="switchCatalog.length">
                            <Select transfer size="small" v-model="acriveSelect" style="width:70px">
                                <Option v-for="(item,index) in switchCatalog" :value="item.id" :key="index">{{item.name}}</Option>
                            </Select>
                            <i-switch 
                                v-if="showSwitch"
                                v-model="acriveSwitch" 
                                disabled 
                                size="small" 
                                style="margin-left: 10px;" 
                                @click.native="changeSwitch"
                            ></i-switch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal
            v-model="isShowModal"
            :mask-closable="false"
            title="请输入密码"
            @on-cancel="clickModalCancel"
        >
            <div class="modal-content">
                <span><em>*</em>账号密码</span>
                <Input v-model="userPassword" type="password" placeholder="账号密码"  />
            </div>
            <template slot="footer">
                <div class="text-align: right;">
                    <Button @click="clickModalCancel">取消</Button>
                    <Button type="primary" :loading="okLoading" @click="clickModalOk">确定</Button>
                </div>
            </template>
        </Modal>
    </div>
</template>
<script>
// 随机字符串
import getRandVal, {getTime} from '@/assets/js/index';
// 加密
import Base64 from '@/assets/js/base64.js';
import md5 from 'js-md5';
    export default {
        data() {
            return {
                loginData: {},
                id: `chart_${Math.random().toString(36).slice(2)}`,
                chart: null,
                activeType: 0,
                activeCate: 0,
                activeTime: 0,
                isShowModal: false, // Modal是否显示
                switchCatalog: [],  // Select列表
                acriveSelect: '',   // 当前Select的值
                showSwitch: false,  // 是否显示Switch开关
                acriveSwitch: false,    // 当前Switch开关的状态
                okLoading: false,
                userPassword: '',   // 输入的密码
                pointId: '',
                pointValue: '',
                dataType: ['安全','用电','能源'],
                dataTime: [{title: '今日', type: 'today'},{title: '昨日', type: 'yesterday'},],
                cateList: [
                    [
                        {title: '压力', type: 'yl',},
                        {title: '流量', type: 'll',},
                        // {title: '水位', type: 'sw',},
                    ],
                    [
                        {title: '电流', type: 'dl',},
                        {title: '电压', type: 'dy',},
                    ],
                    [
                        {title: '负荷', type: 'fh',},
                        {title: '功率', type: 'gl',},
                    ],
                ],
                chartColor: {
                    Ta:'#ffcf39',
                    Tb:'#007b24',
                    Tc:'#ff695f',
                    Tn:'#00a8f8',
                    To:'#00727b',
                    电气温度Ta:'#ffcf39',
                    电气温度Tb:'#007b24',
                    电气温度Tc:'#ff695f',
                    电气温度Tn:'#00a8f8',
                    电气温度To:'#00727b',
                    温度Ta:'#ffcf39',
                    温度Tb:'#007b24',
                    温度Tc:'#ff695f',
                    温度Tn:'#00a8f8',
                    温度To:'#00727b',
                    相电压Uan: '#f5ca1b',
                    相电压Ubn: '#107615',
                    相电压Ucn: '#fe6860',
                    今日: '#00ff43',
                    昨日: '#f700b0',
                    功率因数: '#ffcf39',
                    电流Ia: '#ffcf39',
                    电流Ib: '#007924',
                    电流Ic: '#ff6a5f',
                    预警: '#97b551',
                    隐患: '#2fc7c9',
                    故障: '#58c9b9',
                    报警: '#ffb980'
                },
            }
        },
        computed:{
            stateActive(){
                let arr = ['正常','故障','预警','报警','上线',]
                if(arr.indexOf(this.stateName) > -1){
                    return true
                }
                return false
            }
        },
        watch: {
            acriveSelect(val){
                if(!val) return false
                this.switchCatalog.forEach(item=>{
                    if(item.id == val){
                        this.pointId = item.id
                        this.pointValue = item.pointValue
                        if(item.pointValue == '1'){
                            this.acriveSwitch = true
                        } else {
                            this.acriveSwitch = false
                        }
                        if(item.displayButton == '1'){
                            this.showSwitch = true
                        } else {
                            this.showSwitch = false
                        }
                    }
                })
            }
        },
        props:{
            partId:{
                type: [String, Number],
                required: true,
            },
            width: {
                default: "100%"
            },
            height: {
                default: "220px"
            },
            title: {
                type: Array,
                default () { return [] }
            },
            stateName:{
                default: '--'
            },
            alarmCount:{
                default: 0
            },
            warnCount:{
                default: 0
            },
        },
        methods:{
            //获取数据开始
            getPwdHash(pwd, data) {
                var sha = md5(pwd + data);
                var base = new Base64();
                var pwdHashStr = base.encode(sha);
                return pwdHashStr;
            },
            initEcharts(series, legend, xData){
                legend = legend || [];
                series = series || [];
                if(this.chart && this.chart.dispose){
                    this.chart.dispose()
                }
                let option = {
                    title: {
                        text: `${this.cateList[this.activeType][this.activeCate].title}对比`,
                        top: '2%',
                        left: '3%',
                        textStyle: {
                            color: '#00FFFF',
                            fontSize: 14,
                            fontWeight: 'normal'
                        }
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        top: '10%',
                        data: legend,
                        textStyle: {
                            color: '#00FFFF',
                            fontSize: 12,
                        }
                    },
                    grid: {
                        left: '1%',
                        right: '2%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: xData,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#1B4C4C",
                            }
                        },
                        axisLabel: {
                            textStyle: {color: "#CCCCCC",fontSize: 10},
                            formatter: function(value) {  
                                return value.split(" ").join("\n");  
                            } 
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#1B4C4C",
                            }
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLabel: {textStyle: {color: "#CCCCCC",fontSize: 10}}
                    },
                    series: series
                };
                const _this = this
                this.chart = this.$echarts.init(document.getElementById(this.id));
                this.chart.setOption(option);
                window.addEventListener('resize', function(){
                    _this.chart.resize();
                })
            },
            selectType(index){
                this.activeType = index
                this.activeCate = 0
                this.activeTime = 0
                this.getCurrentData()
            },
            selectCate(index){
                this.activeCate = index
                this.getCurrentData()
            },
            selectTtme(index){
                this.activeTime = index
                this.getCurrentData()
            },
            getCurrentData(){
                let date = this.dataTime[this.activeTime].type
                let type = this.cateList[this.activeType][this.activeCate].type
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/graph/${this.partId}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: type,
                            date: date
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        let data = res.data.data;
                        let series = []
                        let legend = []
                        let xData = []
                        let xIsNull = true
                        let isCoexist = false
                        if(data.hasOwnProperty('today') && data.hasOwnProperty('yesterday')){
                            isCoexist = true
                        }
                        for (let value in data) {
                            let itemData = data[value]
                            let newData = []
                            for(let i = 0; i < itemData.length; i++){
                                // 今天、昨天的数据同时存在
                                if(isCoexist){
                                    let tL = data['today'].length
                                    let yL = data['yesterday'].length
                                    if(yL > tL){
                                        if(value == 'yesterday'){
                                            xData.push(itemData[i].time.substring(11))
                                        }
                                    } else {
                                        if(value == 'today'){
                                            xData.push(itemData[i].time.substring(11))
                                        }
                                    }
                                } else {
                                    if(xIsNull){
                                        xData.push(itemData[i].time)
                                    }
                                }
                                newData.push(itemData[i].value)
                            }
                            if (xData.length){
                                xIsNull = false
                            }
                            let name = value
                            if(value == 'today'){
                                name = '今日'
                            } else if(value == 'yesterday'){
                                name = '昨日'
                            }
                            legend.push(name)
                            series.push({
                                name: name,
                                color: _this.chartColor[name],
                                type: 'line',
                                data: newData,
                            })
                        }
                        _this.initEcharts(series,legend,xData)
                        resolve()
                    }).catch(err => {
                        console.log(err)
                        reject(err)
                    })
                })
            },
            changeSwitch(){
                this.isShowModal = true
            },
            clickModalOk(){
                if(!this.userPassword){
                    return this.$Message.error('请输入密码');
                }
                this.okLoading = true
                this.getSwitchControl()
            },
            clickModalCancel(){
                this.okLoading = false
                this.isShowModal = false
                this.userPassword = ''
            },
            getPointTypes(){
                let url = `/mcbw/network_monitor/pointTypes/${this.partId}`;
                let _this = this;
                var data = {
                    type: 'get',
                    url: url,
                    obj: {
                        orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                    }
                };
                _this.$Axios(data).then((res) => {
                    if(res.data.data && Array.isArray(res.data.data)){
                        let data = res.data.data;
                        if(data.indexOf('kz') != -1){
                            _this.getSwitchCatalog()
                        }
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            getSwitchCatalog(){

                let url = `/mcbw/network_monitor/switch_catalog`;
                let _this = this;
                var data = {
                    type: 'get',
                    url: url,
                    obj: {
                        orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                        partId: this.partId,
                        button: "1",
                        pageSize: 1000,
                        currentPage: 1
                    }
                };
                _this.$Axios(data).then((res) => {
                    if(res.data.data.data && Array.isArray(res.data.data.data)){
                        let data = res.data.data.data;
                        if(data.length){
                            _this.acriveSelect = data[0].id
                            _this.switchCatalog = data
                        }
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            getSwitchControl(){
                let url = `/mcbw/network_monitor/switch_control`;
                let _this = this;
                var data = {
                    type: 'get',
                    url: url,
                    obj: {
                        orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                        pointId: this.pointId,
                        pointValue: this.pointValue,
                        passWord: this.userPassword,
                    }
                };
                _this.$Axios(data).then((res) => {
                    if(res.data.code == 201){
                        this.clickModalCancel()
                        this.getSwitchCatalog()
                        this.$Message.info('修改成功')
                    } else {
                        this.okLoading = false
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
        },
        mounted() {
            if(this.title && this.title[0].name.indexOf('风机') > -1){
                this.cateList[0] = this.cateList[0].splice(0,1)
            }
            this.getPointTypes()
            this.getCurrentData();
            this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/fp/fan-echarts.vue